import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/buttons';
import { useTranslation } from 'react-i18next';
import React from 'react';
import Image from 'next/image';
import { Text } from '@/components/typography';
import { safeOpenJarabot } from '@/utils/jarabot';
export function Chat() {
  const $ = _c(24);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("footer.chatbox.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <h2 id="chatbot" className="mb-3 text-[1.125rem] font-semibold text-white">{t1}</h2>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("footer.chatbox.text");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Text variant="p4" className="mb-6 max-w-[26rem] text-sm text-white">{t3}</Text>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("footer.chatbox.cta");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <Button variant="secondaryDarkBg" testId="openChat" analyticsParam="openChat" onClick={safeOpenJarabot} className="w-full sm:w-auto">{t5}</Button>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t4 || $[15] !== t6) {
    t7 = <div className="flex-1 py-8">{t2}{t4}{t6}</div>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t("footer.chatbox.alt");
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <div className="md:shring-0 hidden w-full max-w-full flex-col items-center justify-end md:flex md:w-[334px]"><Image src="/images/sections/footer/chat.png" width={334} height={220} alt={t8} /></div>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t7 || $[22] !== t9) {
    t10 = <div className="content-visibility-auto relative z-30 bg-blue-900 px-5"><div className="relative m-auto w-full max-w-[38.5rem] lg:max-w-292"><div className="flex flex-col gap-4 md:flex-row">{t7}{t9}</div></div></div>;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}